export default __webpack_public_path__ + "static/media/book-box-shadow.d2b389e1.png";